module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/35_e6b5865a616bce09d0a0fe2af88cb216.jpg";